import { render } from "./Root.vue?vue&type=template&id=382ce342&scoped=true"
import script from "./Root.vue?vue&type=script&lang=js"
export * from "./Root.vue?vue&type=script&lang=js"

import "./Root.vue?vue&type=style&index=0&id=382ce342&scoped=true&lang=css"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382ce342"]])

export default __exports__